import { format } from 'date-fns';

// TODO: uppercase
export const DEFAULT_ERRORS = {
  required: error => `Заполните это поле`,
  requiredTrue: error => `Отметьте это поле`,
  pattern: ({ requiredPattern, actualValue }) => `Неверный формат записи`,
  patternError: ({ mask, maskedValue, value }) => `Неверный формат записи`,
  min: ({ min, actual }) => `Минимум ${min}`,
  max: ({ max, actual }) => `Максимум ${max}`,
  minDate: ({ minValue, value }) => `Минимум ${format(minValue, 'dd.MM.yyyy')}`,
  maxDate: ({ maxValue, value }) => `Максимум ${format(maxValue, 'dd.MM.yyyy')}`,
  minlength: ({ requiredLength, actualLength }) => `Минимум ${requiredLength} символов`,
  maxlength: ({ requiredLength, actualLength }) => `Максимум ${requiredLength} символов`,
  email: error => `Введите корректный адрес электронной почты`,
  attach: error => `Выберите корректные файлы`,
};
